<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-xs-12 p-x-0 m-b-10 flex align-center">
        <router-link :to="{
          name: goBackInfo.name,
          params: goBackInfo.params,
          query: goBackInfo.query
        }">
          <div class="btn btn-default m-r-5 flex">
            <span>返回</span>
            <span v-text="goBackInfo.title" />
            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="col-md-12">
        <cr-option />
      </div>
    </div>
  </section>
</template>

<script>
import crOption from './Temp/CrOptionTemp.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu'

export default {
  name: 'up-menu-option',
  components: {
    'cr-option': crOption
  },
  extends: NdExtendHandleMenu,
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    }
  },
  mounted () {
    this.getExtendHandleMenuInfo()
  }
}
</script>



// WEBPACK FOOTER //
// up-menu-option.vue?2c55068f